export default class Color {
  name = "";
  rgb = 0;

  constructor(name, rgb) {
    this.name = name;
    this.rgb = rgb;
  }

  static yellow = new Color("Yellow", 0xffbf00);
  static red = new Color("Red", 0xff0000);
  static green = new Color("Green", 0x00ff00);
  static blue = new Color("Blue", 0x003399);

  static all = [this.yellow, this.red, this.green, this.blue];

  static getFromRgb(rgb) {
    for (var i = 0; i < this.all.length; i++) {
      if (this.all[i].rgb === rgb) {
        return this.all[i];
      }
    }

    return new Color("Unknown", rgb);
  }

  toString() {
    return this.name;
  }
}

